import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter, HashRouter } from "react-router-dom";
import "./global.css";
import mainAxios from "../src/components/api/index";
import authRequets from "./components/api/authRequests";

mainAxios.interceptors.request.use((config) => {
  if (localStorage.access_token) {
    config.headers.Authorization =
      `bearer ${localStorage.access_token}` || null;
  }
  return config;
});
let authErrorOccured = false;
mainAxios.interceptors.response.use(
  (response) => response,
  (err) => {
    const status = err.response ? err.response.status : null;
    // console.log("error :", err);
    if (status === 401 && !authErrorOccured) {
      authErrorOccured = true;
      localStorage.removeItem("access_token");
      authRequets
        .refreshToken(localStorage.refresh_token)
        .then((d) => {
          console.log("d", d);
          localStorage.access_token = d.data.token;
          localStorage.refresh_token = d.data.refreshToken;
          err.config.headers["Authorization"] =
            "bearer " + localStorage.access_token;
          err.config.baseURL = undefined;
          return mainAxios
            .request(err.config)
            .then((s) => (authErrorOccured = false));
        })
        .catch((e) => {
          console.log("e", e);
          // return Promise.reject(e);
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          // window.location.replace('/')
          authErrorOccured = false;
        });
    }
    return Promise.reject(err);
  }
);
const startApp = () => {
  if (window.cordova) {
    console.log('Runn5211ing cordova-' + window.cordova?.platformId + '@' + window.cordova?.version);
    //document.getElementById('deviceready').classList.add('ready');
    document.addEventListener("pause", window.onPause, false);
    document.addEventListener("resume", window.onResume, false);


    window.permissions = window.cordova?.plugins.permissions;
    window.UmoovePluginStop();
    window.UmoovePluginHidePreview();
  }
  const root = ReactDOM.createRoot(document.getElementById("root"));
  if (window.buildType == "android") {

    root.render(
      //<HashRouter>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      // </HashRouter>
    );
  } else {
    root.render(
      <HashRouter>
        <App />
      </HashRouter>
    );
  }
}
if (window.cordova) {
  document.addEventListener("deviceready", startApp, false)
} else {
  startApp()
}